module.exports = __webpack_public_path__ + "assets/engine-stop-icon.2d51cec1.svg";